import emailjs from "@emailjs/browser";

// ── Initialize EmailJS once when app loads ────────────────────
emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);

const SERVICE_ID       = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ADMIN   = process.env.REACT_APP_EMAILJS_TEMPLATE_ADMIN;
const TEMPLATE_CUSTOMER= process.env.REACT_APP_EMAILJS_TEMPLATE_CUSTOMER;

// ── Email sent to ADMIN when new booking arrives ──────────────
// Admin gets this the moment a customer submits a booking
export async function notifyAdminNewOrder(order) {
  try {
    await emailjs.send(SERVICE_ID, TEMPLATE_ADMIN, {
      admin_name:      "1464 Country Cleaners Admin",
      customer_name:   order.name,
      customer_phone:  order.phone,
      customer_email:  order.email    || "Not provided",
      service:         order.service,
      address:         order.address,
      pickup_date:     order.date,
      order_id:        order.orderId,
      notes:           order.notes    || "None",
    });
    return { success: true };
  } catch (err) {
    console.error("Admin email failed:", err);
    return { success: false, error: err.message };
  }
}

// ── Email sent to CUSTOMER confirming their booking ───────────
// Customer gets this after booking is saved to Firebase
export async function notifyCustomerConfirmation(order) {
  if (!order.email) return { success: false, error: "No email provided" };
  try {
    await emailjs.send(SERVICE_ID, TEMPLATE_CUSTOMER, {
      to_name:     order.name,
      to_email:    order.email,
      order_id:    order.orderId,
      service:     order.service,
      pickup_date: order.date,
      address:     order.address,
    });
    return { success: true };
  } catch (err) {
    console.error("Customer email failed:", err);
    return { success: false, error: err.message };
  }
}